import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/folder/$folderId/$slug')({
  component: () => <Outlet />,
});
